<template>
  <v-container>
    <v-snackbar top v-model="alert.show" multi-line :color="alert.type">
      {{ alert.text }}
      <v-btn text @click="alert.show = false"> Close </v-btn>
    </v-snackbar>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete</v-card-title>
        <v-card-text>Are you sure want delete?</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn :loading="deleteLoading" color="error" @click="remove(temp.id)">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-gallery :images="gallery.file" :index="gallery.index" @close="gallery.index = null" />

    <v-dialog v-model="dialog" max-width="900px">
      <v-card class="pa-2">
        <v-container>
          <v-form ref="form">
            <h3>{{isEdit ? 'Update' : 'Insert'}} Billing
              <v-btn icon class="float-right" @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </h3>
            
            <v-row>
              <v-col md="6">
                <v-autocomplete v-model="form.companyId" :items="companyList" color="white" hide-no-data hide-selected 
                  item-text="name_company" item-value="id" label="Select Company" class="required"
                  @change="getActiveUser($event)" :disabled="isEdit" :rules="rulesRequired">
                </v-autocomplete>
              </v-col>
              <v-col md="6">
                <v-text-field
                  label="Active User"
                  v-model="form.activeUser"
                  disabled>
                </v-text-field>
              </v-col>

              <v-col md="6">
                <v-menu ref="menu" v-model="menu_start" :close-on-content-click="false"
                  transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="dateFormatted(form.currentPayment)" label="Current Payment Date" prepend-icon="mdi-calendar"
                      readonly v-on="on" color="primary" :rules="rulesRequired" class="required">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dateOne" @change="onStartDateChange" no-title scrollable> </v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6">
                <v-menu ref="menu" v-model="menu_end" :close-on-content-click="false"
                  transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="dateFormatted(form.nextPayment)" label="Next Payment Date" prepend-icon="mdi-calendar"
                      readonly v-on="on" color="primary" :rules="rulesRequired" class="required">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dateTwo" @change="onEndDateChange" :min="dateOne" no-title scrollable> </v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="12">
                <v-text-field v-model="form.notes" label="Notes" color="primary"></v-text-field>
              </v-col>
              <v-col md="4">
                <div v-if="isFileAExist">
                  <v-btn icon color="error" class="float-right" @click="deleteFile('FileA')">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <img v-if="!isPDF(form.billingFiles['fileA'])" @click="showImage(form.billingFiles['fileA'])" class="flex" :src="`${form.billingFiles['fileA']}`" alt="FileA" onerror="this.onerror=null;this.src='img/default-image.png'">
                  <label v-if="isPDF(form.billingFiles['fileA'])">
                    <v-icon>mdi-file-pdf-outline</v-icon>
                    Attachment .pdf
                  </label>
                </div>
                <v-file-input v-if="!isFileAExist" :rules="rulesImage" v-model="form.billingFiles['fileA']" accept="image/*, application/pdf" label="File Atacthment 1"></v-file-input>
              </v-col>
              <v-col md="4">
                <div v-if="isFileBExist">
                  <v-btn icon color="error" class="float-right" @click="deleteFile('FileB')">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <img v-if="!isPDF(form.billingFiles['fileB'])" @click="showImage(form.billingFiles['fileB'])" class="flex" :src="form.billingFiles['fileB']" alt="FileB" onerror="this.onerror=null;this.src='img/default-image.png'" />
                  <label v-if="isPDF(form.billingFiles['fileB'])">
                    <v-icon>mdi-file-pdf-outline</v-icon>
                    Attachment .pdf
                  </label>
                </div>
                <v-file-input v-if="!isFileBExist" :rules="rulesImage" v-model="form.billingFiles['fileB']" accept="image/*, application/pdf" label="File Atacthment 2"></v-file-input>
              </v-col>
              <v-col md="4">
                <div v-if="isFileCExist">
                  <v-btn icon color="error" class="float-right" @click="deleteFile('FileC')">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>

                  <img v-if="!isPDF(form.billingFiles['fileC'])" @click="showImage(form.billingFiles['fileC'])" class="flex" :src="form.billingFiles['fileC']" alt="FileC" onerror="this.onerror=null;this.src='img/default-image.png'" />
                  <label v-if="isPDF(form.billingFiles['fileC'])">
                    <v-icon>mdi-file-pdf-outline</v-icon>
                    Attachment .pdf
                  </label>
                </div>
                <v-file-input v-if="!isFileCExist" :rules="rulesImage" v-model="form.billingFiles['fileC']" accept="image/*, application/pdf" label="File Atacthment 3"></v-file-input>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="default" text @click="dialog = false">Cancel</v-btn>
            <v-btn v-if="!isEdit" color="primary" @click="save(form)" :loading="addLoading">Insert</v-btn>
            <v-btn v-if="isEdit"  color="primary" @click="update(form)" :loading="updateLoading">Update</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <div class="billing">
      <v-container>
        <h2>History Payment</h2>
        <v-card class="px-6 pb-0 mb-3 mt-3">
          <v-row>
            <v-col md="3" class="pa-6">
              <v-btn block color="primary" @click="addBilling">
                Add Payment
              </v-btn>
            </v-col>
            <v-col md="3" class="pb-0">
              <v-menu ref="menu" v-model="menu_start_search" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :value="dateFormatted(start_date)" label="Start Date" prepend-icon="mdi-calendar" readonly v-on="on" color="primary" ></v-text-field>
                </template>
                <v-date-picker v-model="start_date" @change="onStartDateFilterChange" no-title scrollable ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="3" class="pb-0">
              <v-menu ref="menu" v-model="menu_end_search" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="dateFormatted(end_date)" label="End Date" prepend-icon="mdi-calendar" readonly v-on="on" color="primary" ></v-text-field>
                </template>
                <v-date-picker v-model="end_date" @change="onEndDateFilterChange" :min="start_date" no-title scrollable ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="3" class="mt-n4 pa-6">
              <v-text-field label="Search" append-icon="mdi-magnify" color="primary" v-model="search" ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

      <v-container>
        <v-card>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="billingList"
            :search="search"
            sort-by="nextPayment"
            :sort-desc="sortDesc"
            class="elevation-1"
            :no-data-text="$t('no_data')"
            :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
          >
             <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
            <template v-slot:item.companyId="{ item }">
              {{ item.company.name_company }}
            </template>
            <template v-slot:item.currentPayment="{ item }">
              {{ dateFormatted(item.currentPayment) }}
            </template>
            <template v-slot:item.company.createdAt="{ item }">
              {{ dateFormatted(item.company.createdAt) }}
            </template>
            <template v-slot:item.nextPayment="{ item }">
              {{ dateFormatted(item.nextPayment) }} 
              <v-btn icon color="warning" v-if="showWarning(item)">
                <v-icon class="blink">mdi-alert-circle</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.billingFiles="{ item }">
              <v-btn class="ma-2" outlined v-for="(data,i) of item.billingFiles" v-bind:key="i" @click="openImageAttachment(data)">
                <v-icon>{{getIcon(data)}}</v-icon> 
                {{'Payment '}} {{i+1}} {{data.fileName}}
              </v-btn>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="editItem(item)">
                <v-icon class="ml-auto mr-auto" small color="primary">
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn icon color="error" @click="deleteConfirmation(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
        <v-skeleton-loader
          class="mx-auto"
          type="table-tbody"
          v-if="firstLoad && loading"
        ></v-skeleton-loader>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment'
import ENV from './../../store/modules/environtment'
export default {
  name: "billing",
  data() {
    return {
      start_date: moment('01 00:00', 'MM hh:mm').startOf('month').format('YYYY-MM-DD'),
      end_date: moment('12 00:00', 'MM hh:mm').endOf('month').format('YYYY-MM-DD'),
      reloadImage: false,
      rulesImage: [
        value => (value == null ? true : value.length == 0 ? true : value.size < 1000000 || 'Image size should be less than 1 MB!'),
      ],
      rulesRequired: [
        (value) => (value == 0 ? true : !!value || this.$i18n.t('required'))
      ],
      gallery: {
        file: [],
        index: 1
      },
      isFileAExist: false,
      isFileBExist: false,
      isFileCExist: false,
      sortDesc: true,
      search: '',
      isEdit: false,
      menu_start: false,
      menu_end: false,
      menu_start_search: false,
      menu_end_search: false,
      addLoading: false,
      updateLoading: false,
      
      form: {
        id: null,
        billingFiles: [],
        companyId: '',
        activeUser: 0,
        currentPayment: moment().format('YYYY-MM-DD'),
        nextPayment: moment().format('YYYY-MM-DD'),
        notes: '',
        path: '',
      },
      sameFileA: false,
      sameFileB: false,
      sameFileC: false,
      alert: {
        show: false,
        type: '',
        text: ''
      },
      deleteDialog: false,
      deleteLoading: false,
      temp: null,
      firstLoad: true,
      headers: [
        { text: "Company Name", value: "companyId" },
        { text: "Join Date", value: "company.createdAt" },
        { text: "Active User", value: "activeUser" },
        { text: "Current Payment", value: "currentPayment" },
        { text: "Next Payment", value: "nextPayment" },
        { text: "Files", value: "billingFiles" },
        { text: "Action", value: "action" },
      ],
      baseUrl: this.$store.state.baseUrl,
      loading: false,
      companyList: [],
      billingList: [],
      dialog: false,
      dateOne: '',
      dateTwo: '',
      lastCompanyItem: []
    }
  },
  methods: {
    isPDF(data) {
      if (data.toLowerCase().includes('.pdf')) {
        return true
      } else {
        return false
      }
    },
    openImageAttachment(data) {
      // if (data.fileName.toLowerCase().includes('pdf')) {
        window.open(data.files, '_blank')
      // } else {
      //   this.gallery.file = [data.files]
      //   this.gallery.index = 0
      // }
    },
    getIcon(data) {
      if (data.fileName) {
        if (data.fileName.toLowerCase().includes('pdf')) {
          return 'mdi-file-pdf-outline'
        } else {
          return 'mdi-file-image-outline'
        }
        
      } else {
        return ''
      }
    },
    showWarning(item) {
      if (this.lastCompanyItem[item.companyId] == item.id) {
        const daysLeft = moment(new Date(item.nextPayment)).diff(moment(), 'days')
        if (daysLeft <= 10 && daysLeft >= 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }

    },
    showImage(item) {
      this.gallery.file = [item]
      this.gallery.index = 0
    },
    dateFormatted(date) {
      return moment(date, 'YYYY-MM-DD').format("DD/MM/YYYY");
    },
    dateFormattedHour(date) {
      return moment(date).format("HH:mm:ss");
    },
    onStartDateChange(event) {
      if (!this.dateTwo) this.dateTwo = this.dateOne
      const diff = moment(this.dateTwo).diff(this.dateOne, 'days')
      if (diff <= 0) {
        this.dateTwo = this.dateOne
        this.form.nextPayment = event
      }
      this.menu_start = false;
      this.form.currentPayment = event
    },
    onEndDateChange(event) {
      this.menu_end = false;
      this.form.nextPayment = event
    },
    async onStartDateFilterChange() {
      const diff = moment(this.end_date).diff(this.start_date, 'days')
      if (diff < 0) this.end_date = this.start_date
      this.menu_start_search = false;
      this.billingList = await this.getBillingList()
    },
    async onEndDateFilterChange() {
      this.menu_end_search = false;
      this.billingList = await this.getBillingList()
    },
    deleteFile(file) {
      switch (file) {
        case 'FileA':
            this.form.billingFiles['fileA'] = null
            this.isFileAExist = false
            this.sameFileA = false
          break
        case 'FileB':
          this.form.billingFiles['fileB'] = null
            this.isFileBExist = false
            this.sameFileB = false
          break
        case 'FileC':
          this.form.billingFiles['fileC'] = null
            this.isFileCExist = false
            this.sameFileB = false
          break
      }
    },
    addBilling() {
      this.isEdit = false
      this.dialog = true
    },
    async getCompanyList() {
      this.loading = true
      const result = await this.$store.dispatch('getCompanyList')
      this.loading = false
      const data = []
      
      result.map(item => {
        if (item.is_active) {
          data.push(item)
        }
      })
      
      return data
    },
    async getActiveUser(companyId) {
      const result = await this.$store.dispatch('getBillingUserCount', {companyId} )
      if (result) {
        this.form.activeUser = result.count
      }
    },
    async getBillingList() {
      const body = {
        startDate: this.start_date,
        endDate: this.end_date
      }
      this.loading = true
      const data = await this.$store.dispatch('getBillingList', body)
      this.loading = false
      this.mappingForGetLastItem(data)
      return data
    },

    mappingForGetLastItem(data) {
      this.lastCompanyItem = []
      data.map(item => {
        if (this.lastCompanyItem[item.companyId]) {
          if (this.lastCompanyItem[item.companyId] < item.id) {
            this.lastCompanyItem[item.companyId] = item.id
          }
        } else {
          this.lastCompanyItem[item.companyId] = item.id
        }
      })

    },
    editItem(item) {      
      if (item.billingFiles) {
        const A = item.billingFiles.find( e => { return ( e.name == 'FileA' ) })
        const B = item.billingFiles.find( e => { return ( e.name == 'FileB' ) })
        const C = item.billingFiles.find( e => { return ( e.name == 'FileC' ) })
        item.billingFiles['fileA'] = A ? A.files : null
        item.billingFiles['fileB'] = B ? B.files : null
        item.billingFiles['fileC'] = C ? C.files : null
        const dataA = A ? true : false
        const dataB = B ? true : false
        const dataC = C ? true : false
        this.isFileAExist = dataA
        this.isFileBExist = dataB
        this.isFileCExist = dataC
        this.sameFileA = dataA
        this.sameFileB = dataB
        this.sameFileC = dataC
      }
      
      this.form = Object.assign({}, item)
      this.isEdit = true
      this.dialog = true
    },
    validateForm(form) {
      if (this.isEdit) {
        if (!form.id) return false
      }
      if (!form.companyId) return false
      if (!form.currentPayment) return false
      if (!form.nextPayment) return false
      return true
    },
    async save(form) {
      if (!this.validateForm(form)) return null
      const formData = new FormData();
      if (form.billingFiles) {
        form.billingFiles['fileA'] ? formData.append("fileA", form.billingFiles['fileA']) : null
        form.billingFiles['fileB'] ? formData.append("fileB", form.billingFiles['fileB']) : null
        form.billingFiles['fileC'] ? formData.append("fileC", form.billingFiles['fileC']) : null
      }
      formData.append('companyId', form.companyId)
      formData.append('activeUser', form.activeUser)
      formData.append('currentPayment', form.currentPayment)
      formData.append('nextPayment', form.nextPayment)
      formData.append('notes', form.notes)
      formData.append('path', `images/${ENV.storage}/billing/${form.companyId}`)

      this.addLoading = true
      const result = await this.$store.dispatch('saveBilling', formData)
      this.addLoading = false
      if (result) {
        this.showMessage('Data successfully inserted', 'success')
        this.refresh()
      }
      this.dialog = false
    },
    async update(form) {
      if (!this.validateForm(form)) return null
      const formData = new FormData();
      if (form.billingFiles) {
        form.billingFiles['fileA'] ? formData.append("fileA", form.billingFiles['fileA']) : null
        form.billingFiles['fileB'] ? formData.append("fileB", form.billingFiles['fileB']) : null
        form.billingFiles['fileC'] ? formData.append("fileC", form.billingFiles['fileC']) : null
      }
      formData.append('id', form.id)
      formData.append('sameFileA', this.sameFileA)
      formData.append('sameFileB', this.sameFileB)
      formData.append('sameFileC', this.sameFileC)
      formData.append('companyId', form.companyId)
      formData.append('activeUser', form.activeUser)
      formData.append('currentPayment', form.currentPayment)
      formData.append('nextPayment', form.nextPayment)
      formData.append('notes', form.notes)
      formData.append('path', `images/${ENV.storage}/billing/${form.companyId}`)

      this.updateLoading = true
      const result = await this.$store.dispatch('editBilling', formData)
      this.updateLoading = false
      if (result) {
        this.showMessage(this.$i18n.t('alert_edit'), 'success')
        this.refresh()
      }
      this.dialog = false
    },
    async remove(id) {
      const body = { id }
      this.deleteLoading = true
      const result = await this.$store.dispatch('deleteBilling', body)
      this.deleteLoading = false
      if (result) {
        this.showMessage(this.$i18n.t('alert_delete'), 'success')
        this.deleteDialog = false
        this.refresh()
      }
    },

    deleteConfirmation(item) {
      this.deleteDialog = true
      this.temp = item
    },

    showMessage(msg, type) {
      this.alert.show = true
      this.alert.type = type
      this.alert.text = msg
    },
    async refresh() {
      this.companyList = await this.getCompanyList()
      this.billingList = await this.getBillingList()
    }
  },
  async created() {
    await this.refresh()
    this.firstLoad = false
  },
  watch: {
    dialog(show) {
      if (show && this.isEdit) {
        this.reloadImage = true
        setTimeout(() => {
          this.reloadImage = false
        }, 10);
      }
      if (show && !this.isEdit) {
        if (this.$refs.form) {
          this.form.billingFiles = []
          this.isFileAExist = false
          this.isFileBExist = false
          this.isFileCExist = false
          this.$refs.form.reset()
        }
      }
    }
  }
}
</script>
<style>
.blueimp-gallery {
  background: rgba(0, 0, 0, 0.7) !important;
}
.blink {
  animation: blink-animation 1s steps(2, start) infinite;
  -webkit-animation: blink-animation 1s steps(2, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
.required label::after {
    content: " *";
    color: red;
}
</style>
